import '@/router/componentHooks';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import svg from './plugins/svg';
import globalDataSocket from './plugins/globalDataSocket';
import './styles/index.scss';
import {abilitiesPlugin} from '@casl/vue';
import {getAppAbility} from '@/abilities/ability';

const ability = getAppAbility();

Vue.use(svg);
// Создаём общий сокет менеджер для данных
Vue.use(globalDataSocket);
Vue.use(abilitiesPlugin, ability);
Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
